// @flow
import * as React from 'react';
import styled from 'styled-components';

type TProps = {
  children: string | React.Node,
  color?: string,
};

const StyledSmall = styled.small`
  font-family: InterRegular;
  color: ${props => props.color || '#000'};
`;


export default function TextStrong(props: TProps): React.Node {
  return (
    <StyledSmall {...props}>
      {props.children}
    </StyledSmall>
  );
}
